import { useEffect, useRef } from 'react'
import config from 'config/app.config'
import { USER_ACTIVITY } from 'socket-resources/event-constants/common-events'
import { io } from 'socket.io-client'

const useUserSocketNameSpace = (token) => {
  const socketRef = useRef(null)

  useEffect(() => {
    if (!token) return

    const socket = io(`${config.SOCKET_URL}/user`, {
      transports: ['polling', 'websocket'],
      auth: { authorization: `Bearer ${token}` }
    })

    socketRef.current = socket

    return () => {
      socket.disconnect()
    }
  }, [token])

  const listenUserActivity = (cb) => {
    if (!socketRef.current || !cb) return
    socketRef.current.on(USER_ACTIVITY, cb)
    return () => {
      socketRef.current?.off(USER_ACTIVITY, cb)
    }
  }

  return listenUserActivity
}

export default useUserSocketNameSpace
